<template>
  <div class="wrapper-content">
    <div class="wrapper">
      <span class="header-icon">
        <i v-if="$route.path === '/users'" class="fas fa-users"></i>
        <i v-if="$route.path === '/integrations'" class="fas fa-link"></i>
        <i
          v-if="$route.path === '/profile-access'"
          class="fas fa-low-vision"
        ></i>
        <i v-if="$route.path === '/branches'" class="fas fa-sitemap"></i>
        <i v-if="$route.path === '/alerts-bulletins'" class="fas fa-bell"></i>
      </span>
      <h2>{{ $route.name }}</h2>
      <div class="mt-4">
        <div v-if="$route.path === '/settings'">
          <general-settings />
        </div>
        <div v-if="$route.path === '/users'">
          <config-users />
        </div>
        <div v-if="$route.path === '/integrations'">
          <integrationsWebhooks />
        </div>
        <div v-if="$route.path === '/profile-access' || $route.path === '/profile-admin-access'">
          <profiles />
        </div>
        <div v-if="$route.path === '/branches'">
          <general-settings />
        </div>
        <div v-if="$route.path === '/alerts-bulletins'">
          <general-settings />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import configUsers from '@/components/molecules/config-users';
import generalSettings from './general-settings';
import profiles from './profiles';
import integrationsWebhooks from './integrations-webhooks';

export default {
  name: 'Configurações',
  components: {
    generalSettings,
    profiles,
    configUsers,
    integrationsWebhooks,
  },

  computed: {
    ...mapState('authentication', ['userProfile']),
  },

  methods: {},

  created() {
    if (!this.userProfile.permissions.config.menu) {
      this.$router.push('404');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper-content {
  padding: 8px;
}
.wrapper {
  width: 100%;
  background-color: $white;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid $gray-light;
  .header-icon {
    float: left;
    font-size: 12px;
    margin-top: 4px;
    padding-right: 12px;
    color: $gray;
  }
  h2 {
    text-transform: uppercase;
    font-size: 21px;
    font-weight: 100;
    color: $gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/index.vue